/**
 * HUB.SMSRoute.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PlatformServiceModel { 
    id?: string;
    serviceId?: string;
    serviceName?: string;
    systemName?: string;
    status?: number;
    owner?: string;
    ownerId?: string;
    description?: string;
    createdDate?: Date;
    updatedDateTime?: Date;
    countryCodeIso?: string;
    countryCode?: string;
}